import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";

@Component({
    template: `<div class="text-red-500 text-sm mb-half" [class.hide]="_hide">{{ _text }}</div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
            .hide {
                display: none;
            }
            div {
                margin-left: 16px;
                margin-top: 8px;
            }
            :host-context(ion-item) div {
                margin-left: 0px;
                margin-top: 0px;
            }
        `,
    ],
})
export class ControlErrorComponent implements OnInit {
    _text;
    _hide = true;

    @Input() set text(value) {
        if (value !== this._text) {
            this._text = value;
            this._hide = !value;
            this.cdr.detectChanges();
        }
    }

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit() {}
}
